import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import type { AdminAuditEntry } from '@/shared/api/types'
import styles from '../AdminPages.module.css'
import { auditActionLabel, auditDetailsText, formatAdminDate } from './format'

export function AdminAuditList({ items }: { items: AdminAuditEntry[] }) {
  return (
    <div className={styles.auditList} aria-label="Список записей журнала">
      {items.map((entry) => {
        const details = auditDetailsText(entry.details)
        const company = entry.targetCompanyId ? (
          <Link className={styles.link} to={`/admin/companies/${entry.targetCompanyId}`}>
            {entry.targetCompanyName || `№ ${entry.targetCompanyId}`}
          </Link>
        ) : (
          '—'
        )
        const user = entry.targetUserId
          ? entry.targetUserEmail || `№ ${entry.targetUserId}`
          : '—'

        return (
          <article key={entry.id} className={styles.auditItem}>
            <div className={styles.auditDesktop}>
              <div className={styles.auditHeader}>
                <p className={styles.auditTitle}>{auditActionLabel(entry.action)}</p>
                <time className={styles.muted} dateTime={entry.createdAt}>
                  {formatAdminDate(entry.createdAt)}
                </time>
              </div>
              <p className={styles.auditMeta}>
                Администратор: {entry.adminEmail || `пользователь № ${entry.adminUserId}`}
                {entry.targetCompanyId && (
                  <>
                    {' · Компания: '}
                    {company}
                  </>
                )}
                {entry.targetUserId && (
                  <>
                    {' · Пользователь: '}
                    {user}
                  </>
                )}
              </p>
              {details && <p className={styles.auditDetails}>{details}</p>}
            </div>

            <dl className={styles.auditMobile}>
              <AuditRow label="Действие" value={auditActionLabel(entry.action)} />
              <AuditRow label="Дата" value={formatAdminDate(entry.createdAt)} />
              <AuditRow
                label="Администратор"
                value={entry.adminEmail || `пользователь № ${entry.adminUserId}`}
              />
              <AuditRow label="Компания" value={company} />
              <AuditRow label="Пользователь" value={user} />
              {details && <AuditRow label="Детали" value={details} mono />}
            </dl>
          </article>
        )
      })}
    </div>
  )
}

function AuditRow({
  label,
  value,
  mono,
}: {
  label: string
  value: ReactNode
  mono?: boolean
}) {
  return (
    <div className={styles.mobileRow}>
      <dt className={styles.mobileLabel}>{label}</dt>
      <dd className={`${styles.mobileValue} ${mono ? styles.mono : ''}`} data-admin-value>
        {value}
      </dd>
    </div>
  )
}
